export class ProfilingEntry {
    configName = "";
    objectId = "";
    workerName = "";
    detail = "";
    nanos = 0;
}
